import { useState, Fragment } from 'react'
import { connect } from 'react-redux'
import { FormattedMessage, useIntl } from 'react-intl'
import ReactTooltip from 'react-tooltip'
import {
  StickyHeader,
  FiltersLa,
  TripsComponent,
  BoatComponent,
} from '../../components'
import { generateMonthPicker } from '../../utils'
import Loader from '../../components/helpers/Loader'
import ItineraryPopup from '../../components/popups/ItineraryPopup'
import {
  MobileFilters,
  MobileViewToggle,
  SearchTypesSelector,
  SearchTypesMobileSelector,
  SortingFilters,
} from '../../components/search'
import {
  SORT_BY,
  GROUP_BY,
  filtersToClean,
  filtersKeys,
} from './search-parameters/liveaboard-parameters'
import { TemporaryBanner } from '../../components/popups/TemporaryBanner'
import messages from '../../messages'
import { setNumberOfTrips } from '../../actions/search-actions'
import {
  insuranceHook,
  searchFiltersHook,
  searchOnInitHook,
} from '../../components/search/hooks'
import { DateFormat } from '../../components/helpers'
import Proptypes from 'prop-types'

const months = generateMonthPicker()

function LiveaboardsSearch({
  pk,
  model,
  title,
  parentSlug,
  parentPk,
  parentModel,
  parentResortDetails,
  resortDetails,
  totalCount,
  pageLoader,
  isNearBy,
  searchFilters,
  inTitle,
  numberOfTrips,
  setNumberOfTrips,
  isWidget,
  filters,
  trustpilotLocale,
  parentTitle,
  parentUrl,
}) {
  const intl = useIntl()
  const insurance = insuranceHook()
  const [numberOfBoatsParent, setNumberOfBoatsParent] = useState(0)
  const {
    transformedFilters,
    filtersCount,
    updateParams,
    updateOrdering,
    triggerApi,
    clearSelectedFilters,
    clearDates,
    handleGroupSelect,
  } = searchFiltersHook(filtersKeys, filtersToClean)
  searchOnInitHook(filtersKeys, 'liveaboard')

  return (
    <div className='search-page-la'>
      <StickyHeader
        locationTitle={title}
        selectedDates={
          <DateFormat
            date={transformedFilters.departure_date}
            format='MMM YYYY'
          />
        }
        typeOfSearch={
          <FormattedMessage id='liveaboards' defaultMessage='Liveaboards' />
        }
      />
      <ReactTooltip type='dark' effect='solid' id='global' />
      <ItineraryPopup />
      <div className='search-wrapper'>
        <div className='main-content'>
          <div className='results-head results-sort-wrapper content-s-b items-center'>
            <h1 className='hidden-xs'>
              {transformedFilters.view === 'dates' ? (
                <FormattedMessage
                  id='search.title.trips'
                  values={{
                    qty: numberOfTrips,
                    location: inTitle,
                  }}
                  defaultMessage='{ qty, plural, one {# trip} other {# trips } } { location }'
                />
              ) : (
                <FormattedMessage
                  id='search.title.boats'
                  values={{
                    qty: numberOfTrips,
                    location: inTitle,
                  }}
                  defaultMessage='{ qty, plural, one {# liveaboard} other {# liveaboards } } { location }'
                />
              )}
            </h1>

            {!window.isWidget && (
              <div className='shop-types-search-page'>
                <SearchTypesSelector
                  activePage={window.typesData && window.typesData.activePage}
                />
                <SearchTypesMobileSelector
                  activePage={window.typesData && window.typesData.activePage}
                />
              </div>
            )}

            <SortingFilters
              updateOrdering={updateOrdering}
              updateViewBy={handleGroupSelect}
              orderingValue={transformedFilters.ordering}
              sortByItems={SORT_BY}
              viewByValue={transformedFilters.view}
              viewByItems={GROUP_BY}
            />
            {isNearBy && (
              <TemporaryBanner
                id='use_map_tip'
                text={intl.formatMessage(messages.use_map_tip, {
                  strong: (str) => <strong>{str}</strong>,
                })}
              />
            )}
          </div>
          <MobileFilters
            updateParams={updateParams}
            filtersCount={filtersCount}
            handleSortSelect={updateOrdering}
            selectedSorting={transformedFilters.ordering}
            sortOptions={SORT_BY}
            hasMap={false}
          />
          <MobileViewToggle
            groupView={transformedFilters.view || 'boats'}
            onToggle={handleGroupSelect}
            groupBy={GROUP_BY}
          />
          <FiltersLa
            model={model}
            pk={pk}
            triggerApi={triggerApi}
            months={months}
            isWidget={isWidget}
            selectedFilters={searchFilters}
            items={filters}
            title={title}
            updateParams={updateParams}
            clearDates={clearDates}
            clearSelectedFilters={clearSelectedFilters}
            trustpilotLocale={trustpilotLocale}
            filtersCount={filtersCount}
            hideRange
          />
          <div className={`result-list ${pageLoader ? 'loading' : ''}`}>
            <Loader />
            {searchFilters.view === 'dates' ? (
              <TripsComponent
                setNumberOfItems={setNumberOfTrips}
                selectedParams={transformedFilters}
                insurance={insurance && insurance[0]}
                model={model}
                numberOfTrips={numberOfTrips}
                resortDetails={resortDetails}
                pk={pk}
              />
            ) : (
              <Fragment>
                <BoatComponent
                  setNumberOfItems={setNumberOfTrips}
                  selectedParams={transformedFilters}
                  insurance={insurance && insurance[0]}
                  model={model}
                  pk={pk}
                  isWidget={isWidget}
                  resortDetails={resortDetails}
                />

                {totalCount < 10 && (
                  <div className='top-level-items'>
                    <h2>
                      <FormattedMessage
                        id='search.other_la'
                        defaultMessage='{qty} other {qty, plural, one {liveaboard} other {liveaboards}}'
                        values={{
                          qty: numberOfBoatsParent,
                        }}
                      />
                      &nbsp;
                      <span dangerouslySetInnerHTML={{ __html: parentTitle }} />
                    </h2>
                    <div className='update-search-wrapper'>
                      <a href={parentUrl} className='btn-red'>
                        <i className='font-icons find-icon' />
                        <FormattedMessage
                          id='update_search'
                          defaultMessage='Update search'
                        />
                      </a>
                      <span>
                        <FormattedMessage
                          id='search.liveaboards_in'
                          defaultMessage='Liveaboards'
                        />
                        &nbsp;
                        <span
                          dangerouslySetInnerHTML={{ __html: parentTitle }}
                        />
                      </span>
                    </div>
                    {!!parentModel && (
                      <BoatComponent
                        parentElement
                        setNumberOfItems={setNumberOfBoatsParent}
                        selectedParams={transformedFilters}
                        slug={parentSlug}
                        model={parentModel}
                        pk={parentPk}
                        resortDetails={parentResortDetails}
                        insurance={insurance && insurance[0]}
                        isWidget={isWidget}
                      />
                    )}
                  </div>
                )}
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default connect(
  (state) => ({
    numberOfTrips: state.numberOfTrips,
    pageLoader: state.pageLoader,
    isNearBy: state.isNearBy,
    searchFilters: state.searchFilters,
  }),
  { setNumberOfTrips },
)(LiveaboardsSearch)

LiveaboardsSearch.propTypes = {
  pk: Proptypes.string,
  model: Proptypes.string,
  title: Proptypes.string,
  parentSlug: Proptypes.string,
  parentPk: Proptypes.string,
  parentModel: Proptypes.string,
  parentResortDetails: Proptypes.object,
  resortDetails: Proptypes.object,
  totalCount: Proptypes.number,
  pageLoader: Proptypes.bool,
  isNearBy: Proptypes.bool,
  searchFilters: Proptypes.object,
  inTitle: Proptypes.string,
  numberOfTrips: Proptypes.number,
  setNumberOfTrips: Proptypes.func,
  isWidget: Proptypes.bool,
  filters: Proptypes.array,
  trustpilotLocale: Proptypes.string,
  parentTitle: Proptypes.string,
  parentUrl: Proptypes.string,
}
